// A topic's slug as the Circles directory `topic` filter accepts it. Stricter
// than the topics admin's own slug rule (which allows a leading hyphen and up
// to 80 characters): the filter only ever matches an existing topic and its
// value is copied verbatim into `rec_serves.filters`, which mirrors to
// BigQuery, so it admits a real slug shape rather than arbitrary text.
//
// Lives in shared so the API's directory query and the web's directory URL
// admit one shape: a value the API would reject never reaches it.
import { z } from 'zod';
export const TOPIC_SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{0,39}$/;
export const TopicSlugSchema = z.string().regex(TOPIC_SLUG_PATTERN);
//# sourceMappingURL=topic-slug.js.map